import { render, staticRenderFns } from "./weeklySugar.vue?vue&type=template&id=37b480a3&scoped=true"
import script from "./weeklySugar.vue?vue&type=script&lang=js"
export * from "./weeklySugar.vue?vue&type=script&lang=js"
import style0 from "./weeklySugar.vue?vue&type=style&index=0&id=37b480a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b480a3",
  null
  
)

export default component.exports